import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AssignmentReportsModel } from 'common/models/page-models/reports/assignment-reports/assignment-report.data-model';
import { AssignmentReportsListingModel } from 'common/models/page-models/reports/assignment-reports/assignment-reports-grid-model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AssignmentReportsWidgetService } from 'common/widget/reports/assignments-reports.widget.service';
 
@Injectable({
    providedIn: 'root'
})
export class AssignmentReportsResolver extends GridResolver<AssignmentReportsModel, AssignmentReportsListingModel> {
    constructor(
        protected fs: AssignmentReportsWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new AssignmentReportsModel();
        return dataModel;
    }
}